import { render, staticRenderFns } from "./ConfigStyle.vue?vue&type=template&id=54fff5ca&scoped=true&"
import script from "./ConfigStyle.vue?vue&type=script&lang=js&"
export * from "./ConfigStyle.vue?vue&type=script&lang=js&"
import style0 from "./ConfigStyle.vue?vue&type=style&index=0&id=54fff5ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fff5ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VColorPicker } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCol,VColorPicker,VList,VListItem,VListItemContent,VListItemTitle,VRow,VTextField})
